import { SyncErrorType } from '@shared/enums';
import { KeyValuePair } from '.';

export interface OfflineSyncResponse {
  errorTitle: string;
  errorMessage: string;
  syncErrorType: SyncErrorType;
  errorDetails: KeyValuePair<string, KeyValuePair<number, string[]>[]>;
  isDprUnlocked: boolean;
}
